import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';
import _ from 'lodash';

export class AeMblListItem extends SearchModelBase {
    id: number = 0;
    closed: string = '';
    isClosed: boolean|null = null;
    shipmentType: string = '';
    invStat: string = '';
    billStat: string = '';
    crDbStat: string = '';
    postDate: string | null = null;
    mawbNo: string = '';
    branch: string = '';
    refNo: string = '';
    hblCount: string = '';
    agentId: number = 0;
    agentName: string = '';
    blEdi: boolean|null = null;
    shipperId: number = 0;
    shipperName: string = '';
    blType: string = '';
    notifyId: number = 0;
    notifyName: string = '';
    pkgs: number = 0;
    fromPkgs: number|null = null;
    toPkgs: number|null = null;
    fltNo: string = '';
    lCode: string = '';
    dCode: string = '';
    etd: string | null = null;
    fromEtd: string | null = null;
    toEtd: string | null = null;
    eta: string | null = null;
    fromEta: string | null = null;
    toEta: string | null = null;
    blDate: string | null = null;
    fromBlDate: string | null = null;
    toBlDate: string | null = null;
    lChgWeight: number|null = null;
    fromLChgWeight: number|null = null;
    toLChgWeight: number|null = null;
    lGrossWeight: number|null = null;
    fromLGrossWeight: number|null = null;
    toLGrossWeight: number|null = null;
    chgWeight: number|null = null;
    fromChgWeight: number|null = null;
    toChgWeight: number|null = null;
    grossWeight: number|null = null;
    fromGrossWeight: number|null = null;
    toGrossWeight: number|null = null;
    carrierSpotNo: string = '';
    pimsLinkId: number = 0;
    createdAt: string | null = null;    
    fromCreatedAt: string | null = null;
    toCreatedAt: string | null = null;
    recognized: string = '';
    paidStatus: string = '';
    paidDate: string | null = null;
    fromPaidDate: string | null = null;
    status: string = '';
    cargoMode: string = '';
    agentRefNo: string = '';
    carrierName: string = '';
    issuingCarrierName: string = '';
    u2Date: string | null = null;
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    u2ID: string = '';
    u1ID: string = '';
    payableToName: string ='';
    firstTo:  string = '';
    projectNo: string = '';
    to1: string = '';
    to2: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'R', width: 30, dataIndex: 'recognized', noNullOrEmptySearch: true, hiddenInColumnSetup: true}),
        XCol.Create({ col: 29, text: 'D/ID', width: 35, dataIndex: 'shipmentType', noNullOrEmptySearch: true}),
        
        XCol.Create({ col: 2, text: 'MAWB', width: 100, dataIndex: 'mawbNo'}),
        XCol.Create({ col: 3, text: 'BR', width: 40, dataIndex: 'branch', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 4, text: 'Project ID', width: 100, dataIndex: 'projectNo'}),
        XCol.Create({ col: 5, text: 'Ref. #', width: 100, dataIndex: 'refNo', defaultColumnFocus : true}),
        XCol.Create({ col: 6, text: 'HAWB(s)', width: 50, dataIndex: 'hblCount', align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 7, text: 'Shipper/Co-Loader', width: 120, dataIndex: 'shipperName'}),
        XCol.Create({ col: 8, text: 'Agent', width: 120, dataIndex: 'agentName'}),
        XCol.Create({ col: 9, text: 'Issuing Carrier', width: 120, dataIndex: 'issuingCarrierName'}),
        XCol.Create({ col: 10, text: 'Flight', width: 60, dataIndex: 'fltNo'}),
        XCol.Create({ col: 11, text: 'First To', width: 80, dataIndex: 'firstTo', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 12, text: 'Departure', width: 60, dataIndex: 'lCode', align: XCol.XAlignType.Center}),
        //XCol.Create({ col: 13, text: 'Agent Ref No', width: 100, dataIndex: 'agentRefNo', visible: false,}),
        //XCol.Create({ col: 15, text: 'Freight Vendor', width: 120, dataIndex: 'payableToName'}),
        //XCol.Create({ col: 16, text: 'Carrier', width: 120, dataIndex: 'carrierName'}),
        XCol.Create({ col: 13, text: 'To 1', width: 60, dataIndex: 'to1'}),
        XCol.Create({ col: 14, text: 'To 2', width: 60, dataIndex: 'to2'}),
        XCol.Create({ col: 15, text: 'Destination', width: 80, dataIndex: 'dCode', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 16, text: 'ETD', width: 75, dataIndex: 'etd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 17, text: 'ETA', width: 75, dataIndex: 'eta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 18, text: 'B/L Type', width: 80, dataIndex: 'blType', noNullOrEmptySearch: true}),
        XCol.Create({ col: 19, text: 'B/L Date', width: 86, dataIndex: 'blDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 20, text: 'PKG(s)', width: 80, dataIndex: 'pkgs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true}),
        XCol.Create({ col: 21, text: 'C. Weight(Lbs)', width: 80, dataIndex: 'lChgWeight', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true}),
        XCol.Create({ col: 22, text: 'G. Weight(Lbs)', width: 80, dataIndex: 'lGrossWeight', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true}),
        XCol.Create({ col: 23, text: 'C. Weight(Kg)', width: 80, dataIndex: 'chgWeight', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.0', noNullOrEmptySearch: true}),
        XCol.Create({ col: 24, text: 'G. Weight(Kg)', width: 80, dataIndex: 'grossWeight', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.0', noNullOrEmptySearch: true}),
        // XCol.Create({ col: 13, text: 'B/L EDI', width: 60, dataIndex: 'blEdi', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: false}),
        XCol.Create({ col: 25, text: 'Carrier Spot', width: 120, dataIndex: 'carrierSpotNo', visible: false}),
        XCol.Create({ col: 26, text: 'FrtChrg', width: 75, dataIndex: 'paidStatus'}),
        XCol.Create({ col: 27, text: 'Paid', width: 75, dataIndex: 'paidDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        
        XCol.Create({ col: 30, text: 'INV', width: 35, dataIndex: 'invStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        XCol.Create({ col: 31, text: 'BIL', width: 35, dataIndex: 'billStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        XCol.Create({ col: 32, text: 'CrDb', width: 40, dataIndex: 'crDbStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        
        XCol.Create({ col: 33, text: 'Create Date', width: 100, dataIndex: 'createdAt', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, visible: false}),
        XCol.Create({ col: 34, text: 'Create by', width: 100, dataIndex: 'u1ID', visible: false}),
        XCol.Create({ col: 35, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, visible: false}),
        XCol.Create({ col: 36, text: 'Update by', width: 100, dataIndex: 'u2ID', visible: false}),
    ];


    public static getExportCollection(useBranch: boolean): XCol.XExportColumn[] {
        let returnCloumns = _.cloneDeep(this.ExportCollection);
        if (!useBranch) returnCloumns = returnCloumns.filter(x => x.dataIndex !== 'branch');
        return returnCloumns;
    };
	
    public static OrderBy = { orderBy: AeMblListItem.prototype.createdAt, orderByAscending: false };


    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        etd: {from: 'fromEtd', to: 'toEtd'},
        eta: {from: 'fromEta', to: 'toEta'},
        blDate: {from: 'fromBlDate', to: 'toBlDate'},
        lChgWeight: {from: 'fromLChgWeight', to: 'toLChgWeight'},
        lGrossWeight: {from: 'fromLGrossWeight', to: 'toLGrossWeight'},
        chgWeight: {from: 'fromChgWeight', to: 'toChgWeight'},
        grossWeight: {from: 'fromGrossWeight', to: 'toGrossWeight'},
        createdAt: {from: 'fromCreatedAt', to: 'toCreatedAt'},
        u2Date: {from: 'fromU2Date', to: 'toU2Date'},
        paidDate: {from: 'fromPaidDate', to: 'toPaidDate'},
        pkgs: {from: 'fromPkgs', to: 'toPkgs'},
    }
}
